<template>
  <v-app dark>
    
    <cookie-consent/>
  </v-app>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import TextBanner from "../components/TextBanner";
import CurrentQuests from "../components/CurrentQuests";
import UpcomingQuests from "../components/UpcomingQuests";
import NewParticipants from "../components/NewParticipants";
import PointsCollectedList from "../components/PointsCollected/PointsCollectedList";
import SwitchOrganizationsBanner from "../components/SwitchOrganizationsBanner";
import routerService from "../services/router";

let prefetchComplete = false;

const prefetch = (next) => {
  prefetchComplete = true;
  Vue.$store.commit("setPrefetchInProgress", true);

  Vue.$store
    .dispatch("dashboard/loadData", { deferredCommit: false })
    .then((commitCallback) => {
      Vue.$store.commit("setPrefetchInProgress", false);

      next(commitCallback);
    });
};

export default {
  components: {
    TextBanner,
    CurrentQuests,
    NewParticipants,
    PointsCollectedList,
    UpcomingQuests,
    SwitchOrganizationsBanner,
  },
  prefetch,
  beforeRouteEnter(to, from, next) {
    if (routerService.isPrefetchRequired(to, from)) {
      prefetch(next);
    } else {
      next();
    }
  },
  computed: {
    ...mapState("organization", {
      selectedOrganizationID: (state) => state.selectedOrganizationID,
      isVisibleOrganizationBanner: (state) => state.showBanner,
    }),
    ...mapState("dashboard", [
      "currentQuests",
      "pointsMessages",
      "upcomingQuests",
      "newParticipants",
    ]),
    ...mapState("user", ["firstname"]),
    refreshProps() {
      const parts = [];
      if (this.selectedOrganizationID) {
        parts.push(this.selectedOrganizationID);
      }
      return parts.join();
    },
    isVisibleWelcomeBanner() {
      let result = false;
      if (
        this.currentQuests &&
        this.currentQuests.length === 0 &&
        this.newParticipants &&
        this.newParticipants.length === 0 &&
        this.pointsMessages &&
        this.pointsMessages.length === 0 &&
        this.upcomingQuests &&
        this.upcomingQuests.length === 0
      ) {
        result = true;
      }
      return result;
    },
  },
  methods: {
    ...mapActions("dashboard", ["refreshPointsList", "loadData"]),
  },
  watch: {
    refreshProps: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          if (!prefetchComplete && oldVal === undefined) {
            this.loadData();
          } else if (oldVal !== undefined && val !== oldVal) {
            this.loadData();
          }
        }
      },
    },
  },
};
</script>
